var _path, _desc;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.99 0.98999H1.98999C1.43999 0.98999 0.98999 1.43999 0.98999 1.98999C0.98999 2.26999 1.09999 2.51999 1.27999 2.69999L5.98999 7.40999V14C5.98999 14.55 6.43999 15 6.98999 15C7.26999 15 7.51999 14.89 7.69999 14.71L9.69999 12.71C9.87999 12.53 9.98999 12.28 9.98999 12V7.40999L14.7 2.69999C14.88 2.51999 14.99 2.26999 14.99 1.98999C14.99 1.43999 14.54 0.98999 13.99 0.98999Z",
    fill: "#8F95B2"
  })), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Filter image")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFilter);
export default __webpack_public_path__ + "static/media/new-filter.2e617034.svg";
export { ForwardRef as ReactComponent };